import { FC } from 'react';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { ReactComponent as Logo } from 'assets/logoDark.svg';
import { EndUserNewPasswordForm } from 'components/Forms/UserForm/SubForms/EndUserGenericForm/EndUserNewPasswordForm';

const NewPassword: FC = () => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.topBar}>
        <Logo style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
      </div>
      <Container maxWidth='xl' className={classes.container}>
        <div className={classes.formContainer}>
          <EndUserNewPasswordForm type='general' />
          {/* <div className={classes.footer}>
            <p>Copyright 2022 9STAR, All Rights Reserved. Version 0.1.39</p>
          </div> */}
        </div>
      </Container>
    </>
  );
};

export default NewPassword;
